import React from 'react';
import {MeetingTabs} from './components/MeetingTabs';
import {InvitationDataGrid} from './components/InvitationDataGrid';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  clientsColumn,
  ownerColumn,
  propositionTypeColumn,
  reviewDueInColumn,
  reviewDueDateColumn,
  rtqStatusColumn,
  ecqStatusColumn,
  inviteColumn,
} from './invitationColumns';
import {InvitationFilters} from './InvitationFilters';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {InvitationFormSchema, InvitationPageProps} from './invitationFormProps';
import {useLocalStorage} from '../../hooks/useLocalStorage';
import {useInvitationState} from './hooks/useInvitationForm';

const ToInviteInner: React.FC = () => {
  // const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowId[]>([]);
  const {values} = useInvitationState('toInvite');
  const columns = [
    clientsColumn,
    ownerColumn,
    propositionTypeColumn,
    reviewDueInColumn,
    reviewDueDateColumn,
    rtqStatusColumn(true),
    ecqStatusColumn(true),
    inviteColumn,
  ];

  return (
    <>
      <InvitationFilters includeATR includeECQ />
      <InvitationDataGrid
        // if we ever want to do multiple:
        // checkboxSelection
        // onRowSelectionModelChange={(newRowSelectionModel) => {
        //   const newRowSelectionModelArray = newRowSelectionModel.map((value) => value);
        //   setRowSelectionModel(newRowSelectionModelArray);
        // }}
        // rowSelectionModel={rowSelectionModel}
        inviteStatus={InvitationReviewsInput.TO_INVITE}
        staff={values?.staff}
        ecqStatus={values?.ecqStatus}
        atrStatus={values?.atrStatus}
        search={values?.search}
        columns={columns}
        entityName="invitations"
        noDataMessage="No invitations found"
      />
    </>
  );
};

const ToInviteWrapped = withAutoFormNew<InvitationFormSchema, InvitationPageProps>(
  ToInviteInner,
  undefined,
  {debugPosition: 'bottom'}
);

export const InvitePage: React.FC = () => {
  const [initialValue] = useLocalStorage<InvitationFormSchema>('toInvite', {
    staff: '',
    search: '',
    atrStatus: 'ALL',
    ecqStatus: 'ALL',
  });
  return (
    <>
      <MeetingTabs />
      <ToInviteWrapped initialValueOverrides={initialValue} formFields={[]} />
    </>
  );
};
